import { MutationTree } from "vuex";
import { UiState } from "@/store/ui/type";

export enum UiMutations {
  IS_TOGGLE_LOGIN = "IS_TOGGLE_LOGIN",
  IS_TOGGLE_MENU = "IS_TOGGLE_MENU",
  IS_TOGGLE_SEARCH = "IS_TOGGLE_SEARCH",
  CLOSE_MENU = "CLOSE_MENU",
  CLOSE_SEARCH = "CLOSE_SEARCH",
  OPEN_SEARCH = "OPEN_SEARCH",
  IS_TOGGLE_CART = "IS_TOGGLE_CART",
  IS_TOGGLE_PRODUCTS_ACTION = "IS_TOGGLE_PRODUCTS_ACTION",
  IS_TOGGLE_NOSTOCK_ACTION = "IS_TOGGLE_NOSTOCK_ACTION",
  SEND_NOTIFICATIONS = "SEND_NOTIFICATIONS",
  DISMIS_NOTIFICATIONS = "DISMISS_NOTIFICATIONS",
  IS_TOGGLE_WELCOME_ACTION = "IS_TOGGLE_WELCOME_ACTION",
  IS_TOGGLE_ADDRESS_ACTION = "IS_TOGGLE_ADDRESS_ACTION",
  IS_TOGGLE_COLISSIMO_ACTION = "IS_TOGGLE_COLISSIMO_ACTION",
  IS_TOGGLE_ADDRESSLIST_ACTION = "IS_TOGGLE_ADDRESSLIST_ACTION",
  IS_TOGGLE_RESET_ACTION = "IS_TOGGLE_RESET_ACTION",
  CHANGE_INDEX = "CHANGE_INDEX",
  GET_GALLERY = "GET_GALLERY",
  CLOSE_LOGIN = "CLOSE_LOGIN",
  SET_RELAIS = "SET_RELAIS",
  SET_CURRENT_LOCAL = "SET_CURRENT_LOCAL",
}

const maxVisibleNotifications = 3;

export const mutations: MutationTree<UiState> = {

  [UiMutations.IS_TOGGLE_PRODUCTS_ACTION](state, { type, product }): void {
    state.isProductsActionModal.open = !state.isProductsActionModal.open;
    state.isProductsActionModal.type = type;
    state.isProductsActionModal.product = product;
  },
  [UiMutations.SET_CURRENT_LOCAL](state, { locale }): void {
    state.currentLocal = locale;
  },
  [UiMutations.SET_RELAIS](state, { selectedRelais }): void {
    state.isColissimoModalOpen.selectedRelais = selectedRelais;
  },
  [UiMutations.IS_TOGGLE_NOSTOCK_ACTION](state, { products }): void {
    state.isNoStockActionModal.open = !state.isNoStockActionModal.open;
    state.isNoStockActionModal.products = products;
  },
  [UiMutations.IS_TOGGLE_COLISSIMO_ACTION](state, { open, address, selectedRelais, shipmentWeight }): void {
    state.isColissimoModalOpen.open = open;
    state.isColissimoModalOpen.address = address;
    state.isColissimoModalOpen.selectedRelais = selectedRelais;
    state.isColissimoModalOpen.shipmentWeight = shipmentWeight;
  },

  [UiMutations.IS_TOGGLE_WELCOME_ACTION](state, { customer }): void {
    state.isWelcomeModal.open = !state.isWelcomeModal.open;
    state.isWelcomeModal.customer = customer;
  },
  [UiMutations.IS_TOGGLE_RESET_ACTION](state, { email, status }): void {
    state.isResetModal.open = !state.isResetModal.open;
    state.isResetModal.email = email;
    state.isResetModal.status = status;
  },
  [UiMutations.IS_TOGGLE_LOGIN](state, { isReloaded }): void {
    state.isLoginModalOpen.open = !state.isLoginModalOpen.open;
    state.isLoginModalOpen.isReloaded = isReloaded;
  },
  [UiMutations.CLOSE_LOGIN](state): void {
    state.isLoginModalOpen.open = false;
  },
  [UiMutations.IS_TOGGLE_SEARCH](state): void {
    state.isSearchOpen = !state.isSearchOpen;
  },
  [UiMutations.CLOSE_SEARCH](state): void {
    state.isSearchOpen = false;
  },
  [UiMutations.OPEN_SEARCH](state): void {
    state.isSearchOpen = true;
  },
  [UiMutations.IS_TOGGLE_ADDRESS_ACTION](state): void {
    state.isAddressModalOpen = !state.isAddressModalOpen;
  },
  [UiMutations.IS_TOGGLE_ADDRESSLIST_ACTION](state): void {
    state.isAddressListModalOpen = !state.isAddressListModalOpen;
  },
  [UiMutations.IS_TOGGLE_MENU](state): void {
    state.isMenuModalOpen = !state.isMenuModalOpen;
  },
  [UiMutations.CLOSE_MENU](state): void {
    state.isMenuModalOpen = false;
  },
  [UiMutations.IS_TOGGLE_CART](state): void {
    state.isCartSidebarOpen = !state.isCartSidebarOpen;
  },
  [UiMutations.GET_GALLERY](state, { gallery }): void {
    state.productGallery = gallery;
  },
  [UiMutations.CHANGE_INDEX](state, { index }): void {
    state.indexGallery = index;
  },

  [UiMutations.SEND_NOTIFICATIONS](state, { notification, id }): void {
    const dismiss = () => {
      const index = state.notifications.findIndex(notification => notification.id === id);
      if (index !== -1) {
        state.notifications.splice(index, 1);
      }
    };

    const newNotification = {
      ...notification,
      id,
      dismiss,
    };

    state.notifications.push(newNotification);

    if (state.notifications.length > maxVisibleNotifications) {
      state.notifications.shift();
    }

  },
  [UiMutations.DISMIS_NOTIFICATIONS](state, id): void {

    const index = state.notifications.findIndex(notification => notification.id === id);
    if (index !== -1) {
      state.notifications.splice(index, 1);
    }

  },
};